var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 214 188",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m107 188c51.915 0 94-42.085 94-94 0-51.915-42.085-94-94-94-51.915 0-94 42.085-94 94 0 51.915 42.085 94 94 94z",
    fill: "#F5F8FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.207 43h167.59c1.646 0 3.225 0.6622 4.389 1.841s1.818 2.7776 1.818 4.4447v31.429c0 1.6671-0.654 3.2659-1.818 4.4447s-2.743 1.841-4.389 1.841h-167.59c-1.6462 0-3.2249-0.6622-4.3889-1.841-1.1641-1.1788-1.818-2.7776-1.818-4.4447v-31.429c0-1.6671 0.6539-3.2659 1.818-4.4447 1.164-1.1788 2.7427-1.841 4.3889-1.841z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m70 65c0-9.9411-8.0589-18-18-18s-18 8.0589-18 18 8.0589 18 18 18 18-8.0589 18-18z",
    fill: "#00578E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m116.25 53h-32.5c-2.0711 0-3.75 1.7909-3.75 4s1.6789 4 3.75 4h32.5c2.071 0 3.75-1.7909 3.75-4s-1.679-4-3.75-4z",
    fill: "#A2DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m138.28 69h-54.56c-2.0545 0-3.72 1.7909-3.72 4s1.6655 4 3.72 4h54.56c2.054 0 3.72-1.7909 3.72-4s-1.666-4-3.72-4z",
    fill: "#D0ECFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m58.75 63.5c0.0985 0 0.196-0.0193 0.2871-0.057 0.091-0.0377 0.1737-0.0929 0.2433-0.1626 0.0696-0.0696 0.1249-0.1523 0.1626-0.2433s0.057-0.1886 0.057-0.2871v-2.25c1e-4 -0.1573-0.0494-0.3107-0.1414-0.4384-0.0921-0.1277-0.222-0.2231-0.3713-0.2728l-6.75-2.25c-0.154-0.0512-0.3205-0.0512-0.4746 0l-6.75 2.25c-0.1493 0.0497-0.2792 0.1451-0.3712 0.2728-0.0921 0.1277-0.1416 0.2811-0.1415 0.4384v2.25c0 0.0985 0.0194 0.1961 0.0571 0.2871 0.0376 0.091 0.0929 0.1737 0.1625 0.2433 0.0697 0.0697 0.1524 0.1249 0.2434 0.1626s0.1885 0.057 0.287 0.057h0.75v5.3882c-0.4374 0.1541-0.8165 0.4398-1.085 0.8179-0.2686 0.3782-0.4136 0.8301-0.415 1.2939v1.5c0 0.0985 0.0194 0.1961 0.0571 0.2871 0.0376 0.091 0.0929 0.1737 0.1625 0.2433 0.0697 0.0697 0.1524 0.1249 0.2434 0.1626s0.1885 0.057 0.287 0.057h13.5c0.0985 0 0.196-0.0193 0.2871-0.057 0.091-0.0377 0.1737-0.0929 0.2433-0.1626 0.0696-0.0696 0.1249-0.1523 0.1626-0.2433s0.057-0.1886 0.057-0.2871v-1.5c-0.0014-0.4638-0.1464-0.9157-0.4149-1.2939-0.2686-0.3781-0.6476-0.6638-1.0851-0.8179v-5.3882h0.75zm-0.75 8.25h-12v-0.75c2e-4 -0.1988 0.0793-0.3895 0.2199-0.5301s0.3313-0.2197 0.5301-0.2199h10.5c0.1989 2e-4 0.3895 0.0793 0.5301 0.2199s0.2197 0.3313 0.2199 0.5301v0.75zm-10.5-3v-5.25h1.5v5.25h-1.5zm3 0v-5.25h3v5.25h-3zm4.5 0v-5.25h1.5v5.25h-1.5zm-9-6.75v-0.9595l6-2.0002 6 2.0002v0.9595h-12z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m181.79 99h-167.59c-3.428 0-6.2069 2.814-6.2069 6.286v31.428c0 3.472 2.7789 6.286 6.2069 6.286h167.59c3.428 0 6.207-2.814 6.207-6.286v-31.428c0-3.472-2.779-6.286-6.207-6.286z",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m52 121c0-9.941-8.0589-18-18-18s-18 8.059-18 18 8.0589 18 18 18 18-8.059 18-18z",
    fill: "#00578E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m40.75 119.5c0.0985 0 0.196-0.019 0.2871-0.057 0.091-0.038 0.1737-0.093 0.2433-0.162 0.0696-0.07 0.1249-0.153 0.1626-0.244s0.057-0.188 0.057-0.287v-2.25c1e-4 -0.157-0.0494-0.311-0.1414-0.438-0.0921-0.128-0.222-0.223-0.3713-0.273l-6.75-2.25c-0.154-0.051-0.3205-0.051-0.4746 0l-6.75 2.25c-0.1493 0.05-0.2792 0.145-0.3712 0.273-0.0921 0.127-0.1416 0.281-0.1415 0.438v2.25c0 0.099 0.0194 0.196 0.0571 0.287 0.0376 0.091 0.0929 0.174 0.1625 0.244 0.0697 0.069 0.1524 0.124 0.2434 0.162s0.1885 0.057 0.287 0.057h0.75v5.388c-0.4374 0.154-0.8165 0.44-1.085 0.818-0.2686 0.378-0.4136 0.83-0.415 1.294v1.5c0 0.099 0.0194 0.196 0.0571 0.287 0.0376 0.091 0.0929 0.174 0.1625 0.244 0.0697 0.069 0.1524 0.124 0.2434 0.162s0.1885 0.057 0.287 0.057h13.5c0.0985 0 0.196-0.019 0.2871-0.057 0.091-0.038 0.1737-0.093 0.2433-0.162 0.0696-0.07 0.1249-0.153 0.1626-0.244s0.057-0.188 0.057-0.287v-1.5c-0.0014-0.464-0.1464-0.916-0.4149-1.294-0.2686-0.378-0.6476-0.664-1.0851-0.818v-5.388h0.75zm-0.75 8.25h-12v-0.75c2e-4 -0.199 0.0793-0.389 0.2199-0.53s0.3313-0.22 0.5301-0.22h10.5c0.1989 0 0.3895 0.079 0.5301 0.22s0.2197 0.331 0.2199 0.53v0.75zm-10.5-3v-5.25h1.5v5.25h-1.5zm3 0v-5.25h3v5.25h-3zm4.5 0v-5.25h1.5v5.25h-1.5zm-9-6.75v-0.959l6-2.001 6 2.001v0.959h-12z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m98.25 109h-32.5c-2.0711 0-3.75 1.791-3.75 4s1.6789 4 3.75 4h32.5c2.071 0 3.75-1.791 3.75-4s-1.679-4-3.75-4z",
    fill: "#A2DAFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m120.28 125h-54.56c-2.0545 0-3.72 1.791-3.72 4s1.6655 4 3.72 4h54.56c2.054 0 3.72-1.791 3.72-4s-1.666-4-3.72-4z",
    fill: "#D0ECFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 18,
    y: 37,
    width: 196,
    height: 60,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.196078 0 0 0 0 0.301961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5854_16312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.196078 0 0 0 0 0.301961 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_5854_16312",
    result: "effect2_dropShadow_5854_16312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.196078 0 0 0 0 0.301961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_5854_16312",
    result: "effect3_dropShadow_5854_16312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5854_16312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 93,
    width: 196,
    height: 60,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.196078 0 0 0 0 0.301961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5854_16312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.196078 0 0 0 0 0.301961 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_5854_16312",
    result: "effect2_dropShadow_5854_16312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.196078 0 0 0 0 0.301961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_5854_16312",
    result: "effect3_dropShadow_5854_16312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5854_16312",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCards);
export default __webpack_public_path__ + "static/media/emptyCards.e489eeb081ffa54c40e3d0ec67ddfe77.svg";
export { ForwardRef as ReactComponent };